module.exports = __webpack_public_path__ + "static/img/ale.26c89ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ale.jpg
// module id = mY7/
// module chunks = 1